/** @format */

import {HotspotVariant} from '../types';
import {HotspotKey} from '../../../types';

interface Options {
  daysLeft: number;
  isTrial: boolean;
  isHighlight: boolean;
  hotspotKey: HotspotKey;
}

const getHotspotVariant = ({
  daysLeft,
  isTrial,
  isHighlight,
  hotspotKey,
}: Options): HotspotVariant => {
  if (!isTrial && !isHighlight) {
    return 'default';
  }

  switch (daysLeft) {
    case 1:
      return hotspotKey === 'mediaplan' ? 'orange' : 'blue';
    case 2:
      return 'blue';
    default:
      return isHighlight ? 'blue' : 'default';
  }
};

export {getHotspotVariant};
